// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"index_boxWrapper_1VEZi","sort-list":"index_sort-list_ScBGJ","sort-item":"index_sort-item_1Wt1p","cursor-pointer":"index_cursor-pointer_LK6hf","txt":"index_txt_15xOc"};